const _mappingMeters = (meters) =>
  meters?.map((meter) => ({
    ...meter,
    label: `${meter.meter_id || ''}: Meter type - ${meter.meter_type.name}`,
    value: { ...meter },
  }))

const _mappingPanels = (panels) =>
  panels?.map((panel) => ({
    ...panel,
    label: panel.name,
    value: { ...panel, meters: _mappingMeters(panel.meters) },
  }))

const _mappingLocation = (locations) =>
  locations?.map((location) => ({
    ...location,
    label: location.name,
    value: { ...location, panels: _mappingPanels(location.panels) },
  }))

export const mappingAdminData = (users) => {
  return users?.map((user) => ({
    ...user,
    label: `${user.first_name} ${user.last_name}`,
    value: { ...user, locations: _mappingLocation(user.locations) },
  }))
}

// first_name: "kon"
// id: "aff55cbb-8b01-44eb-a0d7-b9b01bc01475"
// last_name: "kon"

// id: "71157a0d-e8f5-4afe-ab5c-9116f22fe4a4"
// name: "new location"
// panels

// id: "694e9868-c023-45e8-a4d5-fe6004bbf2cf"
// meter_id: 1
// meter_type:
// id: "a5bc898a-0708-4960-8904-d602e85fca5b"
// name: "20"
// number_of_channels: 30
